module.exports = __webpack_public_path__ + "img/guangzhouta.16d0aa91.png";